import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PercentageSlider } from './percentageSlider';

export const SidebarSkillList = props => (
  <div className="professional-skills-list sidebar-section">
    {props.skills.map(s => (
      <div className="professional-skills-list-item" key={s.name}>
        <div className={"professional-skills-list-item-icon-wrapper"}>
          <FontAwesomeIcon icon={s.icon} />
          <span>{s.name}</span>
        </div>
        <div className={"professional-skills-list-item-subtitle"}>
          {s.description}
        </div>
        <PercentageSlider percentage={s.percentage} />
      </div>
    ))}
  </div>
);

SidebarSkillList.propTypes = {
  skills: PropTypes.array.isRequired,
};
